/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_New_OrderInputs */

const en_status_new_order = /** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Transaction`)
};

const es_status_new_order = /** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva Transacción`)
};

const fr_status_new_order = /** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle transaction`)
};

const de_status_new_order = /** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Transaktion`)
};

const id_status_new_order = /** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaksi Baru`)
};

/** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */
const ja_status_new_order = en_status_new_order;

/** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */
const zh_status_new_order = en_status_new_order;

/** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */
const ar_status_new_order = en_status_new_order;

/** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */
const it_status_new_order = en_status_new_order;

/** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */
const ru_status_new_order = en_status_new_order;

/** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */
const pt_status_new_order = en_status_new_order;

/** @type {(inputs: Status_New_OrderInputs) => LocalizedString} */
const ko_status_new_order = en_status_new_order;

/**
* | output |
* | --- |
* | "New Transaction" |
*
* @param {Status_New_OrderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const status_new_order = /** @type {((inputs?: Status_New_OrderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_New_OrderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_new_order(inputs)
	if (locale === "es") return es_status_new_order(inputs)
	if (locale === "fr") return fr_status_new_order(inputs)
	if (locale === "de") return de_status_new_order(inputs)
	if (locale === "ja") return ja_status_new_order(inputs)
	if (locale === "zh") return zh_status_new_order(inputs)
	if (locale === "ar") return ar_status_new_order(inputs)
	if (locale === "id") return id_status_new_order(inputs)
	if (locale === "it") return it_status_new_order(inputs)
	if (locale === "ru") return ru_status_new_order(inputs)
	if (locale === "pt") return pt_status_new_order(inputs)
	return ko_status_new_order(inputs)
});